import {TranslateService} from '@ngx-translate/core';
import {Component, forwardRef, Inject, Injector, Input} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ModalResult} from "../model/common.model";
import {AlertService} from "../services/alert.service";
import {SessionService} from "../services/session.service";
import {ClientService} from "../services/client.service";
import {DomSanitizer} from "@angular/platform-browser";
import {Utils} from "../model/Utils";

@Component({
  templateUrl: 'DlgUpdateEmailComponent.html',
})
export class DlgUpdateEmailComponent {
  @Input() loading = false;

  employeeId: string;
  email: string;

  focusEmail = false;

  constructor(public activeModal: NgbActiveModal, private injector: Injector,
              @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
              @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
              @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
              @Inject(forwardRef(() => Router)) private router: Router,
              @Inject(forwardRef(() => SessionService)) private session: SessionService, private translate: TranslateService) {

  }


  public populate( employeeId: string, email: string) {
    this.employeeId = employeeId;
    this.email = email;
  }

  isEmailValid(){
    return Utils.isValidEmail(this.email)
  }
  /*
  isPwdValid(){
    if (this.newPassword!=null && this.newPassword2!=null){
      if (this.newPassword === this.newPassword2){
        return true;
      }
    }
    return false;
  }
  */

  onUpdate() {
    this.loading = true;

    this.clientService.saveEmployeeEmailOnly(this.employeeId,this.email).then(
      (res) => {
        if (res.success) {
          console.log('Information is ' + JSON.stringify(res.data, null, 1));
          this.activeModal.close(ModalResult.OK);
        } else {
          console.log('Error ' + res.description);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );
  }

  onCancel() {
    this.activeModal.close(ModalResult.CANCEL);
  }


}
